import { render } from "./AsSupportNotAuth.vue?vue&type=template&id=4e9242a8&scoped=true&ts=true"
import script from "./AsSupportNotAuth.vue?vue&type=script&lang=ts"
export * from "./AsSupportNotAuth.vue?vue&type=script&lang=ts"

import "./AsSupportNotAuth.vue?vue&type=style&index=0&id=4e9242a8&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9242a8"]])

export default __exports__